module.exports = __webpack_public_path__ + "img/pepe-unhappy3.b24161c0.gif";